export default function About() {
  return (
    <div className="about-page">

      {/* WHO WE ARE - Heading Style Updated */}
      <div className="about-container">
        <div className="about-grid">
          <div className="about-text">

            {/* --- Updated Heading Style --- */}
            <h2
              className="about-heading"
              style={{
                fontSize: "42px",
                fontWeight: "800",
                marginBottom: "20px",
                marginTop: "-35px",
                color: "#0f2b46"
              }}>
              Who We Are
              <div style={{
                width: "60px",
                height: "4px",
                backgroundColor: "#94a3b8",
                marginTop: "10px",
                borderRadius: "2px"
              }}></div>
            </h2>
            {/* ---------------------------- */}

            <p>
              <strong>Manoj V. Ayadi & Associates</strong>, Practising Company Secretaries, is a professionally managed firm delivering high-quality corporate, legal, and regulatory advisory services in India. We combine deep technical expertise with a pragmatic, business-oriented approach to support organisations in meeting their compliance obligations and strategic objectives.
            </p>

            <p>
              Our firm works closely with startups, SMEs, and established enterprises, offering tailored solutions across company law, secretarial compliances, FEMA, capital markets, and corporate structuring. We are committed to the highest standards of professionalism, integrity, and responsiveness.
            </p>

            <p>
              At Manoj V. Ayadi & Associates, we don’t just ensure compliance—we enable businesses to operate with confidence, clarity, and strong governance.
            </p>


          </div>
<div className="about-image">         
            <img
              src="https://www.canaveedmulla.com/images/llp_home.svg"
              alt="law office"
              style={{ width: "100%", maxWidth: "450px", transform: "translateY(-20px)" }}
            />
          </div>
        </div>
      </div>

      {/* MISSION & VALUES - Heading Style Updated */}
      <div className="mission-section">

        {/* --- Updated Heading Style (Professional Header) --- */}
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{
            fontSize: "38px",
            fontWeight: "900",
            color: "#0f2b46",
            textTransform: "uppercase",
            letterSpacing: "1px",
            margin: "0"
          }}>
            Our Mission & Values
          </h2>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "10px" }}>
            <div style={{ width: "60px", height: "3px", backgroundColor: "#94a3b8" }}></div>
            <div style={{ width: "80px", height: "12px", backgroundColor: "#0f2b46" }}></div>
            <div style={{ width: "60px", height: "3px", backgroundColor: "#94a3b8" }}></div>
          </div>
        </div>
        {/* -------------------------------------------------- */}

        <div className="mission-grid">

          {/* CARD 1 */}
          <div className="mission-card" style={{
            background: "#ffffff",
            padding: "30px 25px",
            borderRadius: "15px",
            boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
            border: "1px solid #e2e8f0",
            textAlign: "center",
            transition: "0.3s",
            position: "relative"
          }}
            onMouseEnter={e => e.currentTarget.style.transform = "translateY(-8px)"}
            onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
          >

            <div className="mission-icon" style={{
              fontSize: "28px",
              width: "60px",
              height: "60px",
              margin: "0 auto 15px",
              borderRadius: "50%",
              background: "#eff6ff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid #bfdbfe"
            }}>
              🤝
            </div>

            <h3 style={{ color: "#1a3c6e", fontWeight: "700", marginBottom: "10px" }}>
              Client Commitment
            </h3>

            <p style={{ color: "#475569", fontSize: "15px", lineHeight: "1.6" }}>
              To consistently deliver outstanding services to our clients and
              provide fulfilling careers and professional satisfaction for our
              people while achieving financial success.
            </p>

            {/* bottom accent */}
            <div style={{
              width: "50px",
              height: "4px",
              background: "#94a3b8",
              borderRadius: "10px",
              margin: "20px auto 0"
            }}></div>
          </div>


          {/* CARD 2 */}
          <div className="mission-card" style={{
            background: "#ffffff",
            padding: "30px 25px",
            borderRadius: "15px",
            boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
            border: "1px solid #e2e8f0",
            textAlign: "center",
            transition: "0.3s"
          }}
            onMouseEnter={e => e.currentTarget.style.transform = "translateY(-8px)"}
            onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
          >

            <div className="mission-icon" style={{
              fontSize: "28px",
              width: "60px",
              height: "60px",
              margin: "0 auto 15px",
              borderRadius: "50%",
              background: "#eff6ff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid #bfdbfe"
            }}>
              🔍
            </div>

            <h3 style={{ color: "#1a3c6e", fontWeight: "700", marginBottom: "10px" }}>
              Integrity & Transparency
            </h3>

            <p style={{ color: "#475569", fontSize: "15px", lineHeight: "1.6" }}>
              We uphold the highest standards of integrity, honesty and secrecy
              in all our dealings while emphasizing transparency,
              accountability and professionalism.
            </p>

            <div style={{
              width: "50px",
              height: "4px",
              background: "#94a3b8",
              borderRadius: "10px",
              margin: "20px auto 0"
            }}></div>
          </div>


          {/* CARD 3 */}
          <div className="mission-card" style={{
            background: "#ffffff",
            padding: "30px 25px",
            borderRadius: "15px",
            boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
            border: "1px solid #e2e8f0",
            textAlign: "center",
            transition: "0.3s"
          }}
            onMouseEnter={e => e.currentTarget.style.transform = "translateY(-8px)"}
            onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
          >

            <div className="mission-icon" style={{
              fontSize: "28px",
              width: "60px",
              height: "60px",
              margin: "0 auto 15px",
              borderRadius: "50%",
              background: "#eff6ff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid #bfdbfe"
            }}>
              📈
            </div>

            <h3 style={{ color: "#1a3c6e", fontWeight: "700", marginBottom: "10px" }}>
              Client Growth
            </h3>

            <p style={{ color: "#475569", fontSize: "15px", lineHeight: "1.6" }}>
              We believe our growth is directly related to the success and
              development of our esteemed clients and we strive to help
              them achieve their goals.
            </p>

            <div style={{
              width: "50px",
              height: "4px",
              background: "#94a3b8",
              borderRadius: "10px",
              margin: "20px auto 0"
            }}></div>
          </div>

        </div>
      </div>
    </div>
  );
}